import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const downloadOrderDetail = createAsyncThunk('download/orderDetail', async (transactionKey, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/orders/${transactionKey}/export?type=pdf`, {
      responseType: 'blob',
      timeout: 20000, // Set timeout to 20 seconds for PDF generation
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    // a.download = `invoice-${orderKey}.pdf`;
    a.download = `${transactionKey}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
